import type { NavigateFunction } from 'react-router-dom';

/**
 * Follows a notification's link: an Owner Studio path ("/wallet") in the app, an https address in a new tab.
 * Owner Hub accepts only those two (docs/owner-notifications.md there); anything else is ignored, above all a path
 * that a browser would read as another host ("//x", "/\\x").
 */
export const followNotificationLink = (link: string, navigate: NavigateFunction): void => {
  if (/^\/(?![/\\])[^\s\\]*$/.test(link)) {
    navigate(link);
    return;
  }
  if (link.startsWith('https://')) window.open(link, '_blank', 'noopener,noreferrer');
};
